/**
 * Indica que el datepicker generará un string como valor final para formik
 */
export const PRODUCE_STRING = 'string';

/**
 * Indica que el datepicker generará un objeto Date como valor final para formik
 */
export const PRODUCE_DATE = 'date';

/**
 * Indica el formato por defecto para los datepicker
 */
export const DP_DEFAULT_FORMAT = 'YYYY-MM-DD';

/**
 * Indica el formato por defecto para los datetimepicker
 */
export const DTP_DEFAULT_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/**
 * Indica el formato para lo timepickerbase sin segundos
 */
export const TP_NO_SECONDS_FORMAT = 'HH:mm';
